import React from "react";
import { FiServer, FiCpu, FiArrowRight, FiZap, FiCloud } from "react-icons/fi";
import { SiEthereum } from "react-icons/si";

export default function DeepOrbCapabilities() {

const cards = [
    {
      title: "AI Agents",
      icon: <FiZap className="h-7 w-7" aria-hidden="true" />,
      blurb:
        "Build intelligent agents that solve real business problems—from automating workflows to enhancing products with AI-powered decision-making.",
      bullets: ["Custom agent development", "Production-ready solutions", "Rapid prototyping to deployment"],
      ctaLabel: "Build Agents",
      href: "/services/ai-agents",
      accentFrom: "from-purple-500",
      accentTo: "to-pink-600",
    },
    {
      title: "MCP Connectors",
      icon: <FiCpu className="h-7 w-7" aria-hidden="true" />,
      blurb:
        "Unlock the power of your data with LLM-powered analysis. We build secure connectors that expose your systems for intelligent insights.",
      bullets: ["Data integration expertise", "LLM-ready architecture", "Secure access patterns"],
      ctaLabel: "Accelerate Data",
      href: "/services/mcp-connectors",
      accentFrom: "from-cyan-300",
      accentTo: "to-purple-500",
    },
    {
      title: "Blockchain & DeFi",
      icon: <SiEthereum className="h-7 w-7" aria-hidden="true" />,
      blurb:
        "From DeFi protocols to tokenized real-world assets, we architect and deploy blockchain solutions that unlock new markets and capabilities.",
      bullets: ["Smart contract development", "RWA tokenization", "DeFi product launch"],
      ctaLabel: "Explore Blockchain",
      href: "/services/blockchain",
      accentFrom: "from-blue-400",
      accentTo: "to-cyan-500",
    },
    {
      title: "Cloud Architecture",
      icon: <FiCloud className="h-7 w-7" aria-hidden="true" />,
      blurb:
        "Scale with confidence on AWS and Google Cloud. Deep architectural expertise to operationalize your infrastructure and support rapid growth.",
      bullets: ["Multi-cloud expertise", "Production-grade systems", "Performance at scale"],
      ctaLabel: "Scale Smart",
      href: "/services/cloud-architecture",
      accentFrom: "from-cyan-400",
      accentTo: "to-blue-600",
    },
  ];


  return (
    <section className="relative w-full bg-[#0b0f14] text-slate-200 py-10 sm:py-10">
      {/* Background accent */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 -top-24 h-64"
      />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 rounded-full border border-cyan-500/30 bg-cyan-500/10 px-3 py-1 text-xs tracking-wide text-cyan-300">
            Cloud • AI • Blockchain
          </span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl text-white">
            Build AI agents & DeFi apps that react to reality
          </h2>
          <p className="mt-3 text-gray-200 max-w-2xl mx-auto">
            Whether you're creating intelligent agents that transform operations, unlocking insights from your data through LLM-powered analysis, pioneering DeFi products and real-world assets, or architecting cloud systems that scale—we are an idea accelerator team that makes it happen. Our deep expertise across AI, blockchain, and cloud infrastructure means we speak your language, and will transform big ideas into reality.
          </p>
        </div>

        {/* Responsive cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card) => (
            <article
              key={card.title}
              tabIndex={0}
              className="group relative rounded-2xl border border-white/5 bg-white/5 backdrop-blur-sm p-6 shadow-lg outline-none transition transform hover:-translate-y-0.5 hover:shadow-cyan-900/20 focus:shadow-cyan-900/30"
            >
              {/* Accent bar */}
              <div
                className={`absolute inset-x-0 -top-px h-0.5 bg-gradient-to-r ${card.accentFrom} ${card.accentTo} opacity-80`}
                aria-hidden="true"
              />

              <div className="flex items-center gap-4">
                <div className="rounded-xl p-3 bg-gradient-to-br from-cyan-500/15 to-purple-500/15 text-cyan-300 group-hover:text-cyan-200">
                  {card.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-100">{card.title}</h3>
              </div>

              <p className="mt-4 text-slate-400 leading-relaxed">{card.blurb}</p>

              <ul className="mt-4 space-y-2 text-sm">
                {card.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2">
                    <span className="mt-1 h-1.5 w-1.5 rounded-full bg-gradient-to-r from-cyan-400 to-purple-500 flex-none" />
                    <span className="text-slate-300">{b}</span>
                  </li>
                ))}
              </ul>

              {/* <a
                href={card.href}
                className="mt-6 inline-flex items-center gap-2 rounded-lg border border-cyan-500/30 bg-cyan-500/10 px-3 py-2 text-sm font-medium text-cyan-300 transition hover:bg-cyan-500/20 focus-visible:ring-2 focus-visible:ring-cyan-400"
              >
                {card.ctaLabel}
                <FiArrowRight className="h-4 w-4" aria-hidden="true" />
              </a> */}

              {/* Glow on hover */}
              <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-white/5 group-hover:ring-cyan-400/30 transition"
              />
            </article>
          ))}
        </div>

        {/* Footer line accent */}
        <div
          aria-hidden="true"
          className="mt-12 h-px w-full bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent"
        />
      </div>
    </section>
  );
}
